import { useState, useEffect } from "react";
import { KTSVG } from "../../../helpers/KTSVG";
import { useDebounce } from "../../../hooks/useDebounce";
import useTableCtx from "../tableContext/useTableCtx";
import { tableControlBaseClasses } from "./tableControlStyles";

const TableSearch = ({
  value,
  withSearch,
}: {
  value: string;
  withSearch?:
    | boolean
    | {
        placeholder?: string;
        withoutSearchIcon?: boolean;
        withoutSearchClear?: boolean;
        searchDelay?: number;
      };
}) => {
  const { placeholder, withoutSearchIcon, withoutSearchClear, searchDelay } =
    withSearch as {
      placeholder?: string;
      withoutSearchIcon?: boolean;
      withoutSearchClear?: boolean;
      searchDelay?: number;
    };
  const { tableSearch, handleTableSearch } = useTableCtx()!;

  const contextValue = tableSearch?.[value] ?? "";

  const [searchTerm, setSearchTerm] = useState<string>(contextValue);

  const debouncedSearchTerm = useDebounce(searchTerm, searchDelay || 1000);

  useEffect(() => {
    if (contextValue !== searchTerm) {
      setSearchTerm(contextValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue]);

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && debouncedSearchTerm !== null) {
      handleTableSearch(value, debouncedSearchTerm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  return (
    <div>
      <div className="relative flex items-center">
        {!withoutSearchIcon && (
          <KTSVG
            path="/media/icons/duotune/general/gen021.svg"
            className="absolute left-2"
            svgClassName="h-5 w-5"
          />
        )}
        <input
          type="text"
          data-kt-user-table-filter="search"
          className={`${tableControlBaseClasses} w-full min-w-0 pr-9 ${
            withoutSearchIcon ? "pl-4" : "pl-9"
          }`}
          placeholder={placeholder}
          value={searchTerm || ""}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && searchTerm.length > 0 && !withoutSearchClear && (
          <button
            className="absolute right-1 inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent transition hover:bg-surface-hover"
            onClick={() => setSearchTerm("")}>
            <KTSVG
              path="/media/icons/duotune/general/gen040.svg"
              svgClassName="h-5 w-5"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export { TableSearch };
